import React, { useEffect } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  AppDispatch,
  fetchAvatar,
  fetchChildCertificate,
  fetchIdCard,
  RootState,
} from 'data';
import { MobileTabBar, Navbar } from 'components';
import {
  fetchAddress,
  fetchBankInfo,
  fetchPersonalInfo,
  fetchProfile,
} from 'data/slices/profileSlice';

export const PrivateRouting = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { isAuthenticated, loginLoading, user } = useSelector(
    (state: RootState) => state.auth,
  );

  useEffect(() => {
    if (!user) {
      dispatch(fetchProfile());
      dispatch(fetchAddress());
      dispatch(fetchBankInfo());
      dispatch(fetchPersonalInfo());
      dispatch(fetchAvatar());
      dispatch(fetchChildCertificate());
      dispatch(fetchIdCard());
    }
  }, [dispatch, user]);

  if (loginLoading) {
    return (
      <div className="flex items-center justify-center h-svh w-full bg-[#F5F7F9]">
        <div className="w-10 h-10 border-4 border-gray-300 border-t-[#FF6F61] rounded-full animate-spin"></div>
      </div>
    );
  }

  if (isAuthenticated) {
    return (
      <>
        <Navbar />
        <Outlet />
        <MobileTabBar />
      </>
    );
  } else {
    return <Navigate to="/login" replace />;
  }
};
